import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import Topbar from "../../../Component/Topbar/Topbar";
import { get, post } from "../../redux/api/ApiHandler";
import { URLS } from "../../redux/api/Constants";
import toast from "react-hot-toast";
import { current } from "@reduxjs/toolkit";

const PendingMove = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const formType = location.state?.type; // "add" | "edit" | "view"
  const existingData = location.state?.data; // Prefill for edit/view
  const isViewMode = formType === "view";
  const isEditMode = formType === "edit";
  const [popup, setPopup] = useState(false);
  const [description, setDescription] = useState("");
  const [regionOptions, setRegionOptions] = useState([]);

  const team = location?.state?.team;
  const id = location?.state?.id;
  const status = location?.state?.status;
  const ticket = location?.state?.ticket;


  const customer_id = location?.state?.customerId;
  const region_id = location?.state?.regionId;
  const servEng_id = location?.state?.servEngId;
  const regMan_id = location?.state?.regManId;
  const cusPrinterId = location?.state?.cusPrinterId;



  const {
    control,
    handleSubmit,
    setValue,
    getValues,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      regionname: "",
      location: "",
    },
  });


  const customStyles = {
    control: (provided) => ({
      ...provided,
      borderRadius: "8px",
      borderColor: "#D9D9D9",
      minHeight: "40px",
      fontSize: "14px",
    }),
  };


  const handlePopup = () => {
    let values = getValues();


    if (!description) {
      toast.error("Enter Description");
      return;
    }
    if (!values?.location?.value) {
      toast.error("Enter Department");
      return;
    }

    setPopup(true);
  }



  const closeTicket = async () => {
    let values = getValues();

    let payload = {
      assigned_id: values?.location?.value,
      remarks: description,
      current_status: status == 3 ? 4 : status == 5 ? 6 : status == 11 ? 12 : "",
      region_id: region_id,
      regional_manager_id: regMan_id,
      service_engineer_id: servEng_id,
      customer_id: customer_id,
      customer_printer_id: cusPrinterId,
      support_needed: status == 3 ? 2 : status == 5 ? 1 : status == 11 ? 4 : "",
      status: 2,
    }
    // console.log(":payload", payload);
    // return;

    let res = await post(URLS.TICKET_CLOSE + id, payload)
    if (res?.status == "success") {
      toast.success(res?.message);
      setPopup(false);
      navigate("/pending-table");

    }
  }


  const inventoryList = async () => {
    setValue("regionname", status == 5 ? "Technical" : status == 3 ? "Inventory" : status == 7 ? " Next Visit" : status == 11 ? "Senior Support" : "-")
    // let res = await get(team == 1 ? URLS.TECHNICAL_LIST : team == 2 ? URLS.INVENTORY_LIST : team == 3 ? URLS.INVENTORY_LIST : team == 4 ? URLS.INVENTORY_LIST : "");

    const url =
      status == 5 ? URLS.TECHNICAL_LIST :
        status == 3 ? URLS.INVENTORY_LIST :
          status == 7 ? URLS.INVENTORY_LIST :
            status == 11 ? URLS.DEPARTMENT_LIST :
              "";

    let res;

    // If status == 11 → POST call
    if (status == 11) {
      const payload = {
        role: 5,
        region_id: region_id,
      };

      res = await post(url, payload);
    }

    // Other statuses → GET call
    else {
      res = await get(url);
    }

    // Determine correct key for response
    const listKey =
      status == 5 ? "technicalList" :
        status == 3 ? "inventoryList" :
          status == 7 ? "inventoryList" :
            status == 11 ? "data" :
              "";

    // Extract list safely
    const list = res?.[listKey];

    if (res?.status === "success" && Array.isArray(list)) {
      const options = list.map(item => ({
        value: item?.id,
        label: item?.name,
      }));

      setRegionOptions(options);
    }

  }

  useEffect(() => {
    inventoryList()
  }, []);


  return (
    <div>
      <Topbar header="Pending" subHead="Edit / Move" />

      <div className="container_fluit1 px-4 py-3">
        <label className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-19 fs-xxl-20 mb-3 mt-3">
          Regional Ticket ID :{" "}
          <span className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-19 fs-xxl-20">
            {ticket}
          </span>
        </label>

        <form
          className="d-flex flex-wrap gap-5"
        // onSubmit={handleSubmit(onSubmit)}
        >
          {/* Region Select */}
          <div className="col-md-5">
            <Controller
              control={control}
              name="regionname"
              rules={{ required: "Team is required" }}
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    Choose the Team
                  </label>
                  <input
                    {...field}
                    className="input-box"
                    placeholder="Enter Team"
                    disabled
                  />
                  {errors.regionname && (
                    <p style={{ color: "red" }}>{errors.regionname.message}</p>
                  )}
                </div>
              )}
            />
          </div>

          {/* Location Select */}
          <div className="col-md-5">
            <Controller
              control={control}
              name="location"
              rules={{ required: "Department is required" }}
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    {status == 5 ? "Technical" : status == 3 ? "Inventory" : status == 7 ? " Next Visit" : status == 11 ? "Senior Support" : "-"} Department
                  </label>
                  <Select
                    {...field}
                    options={regionOptions}
                    placeholder="Select Department"
                    isSearchable
                    onChange={field.onChange}
                    value={field.value}
                    styles={customStyles}
                    isDisabled={isViewMode}
                  />
                  {errors.location && (
                    <p style={{ color: "red" }}>{errors.location.message}</p>
                  )}
                </div>
              )}
            />
          </div>

          <div className="col-md-11 mt-3">
            <Controller
              control={control}
              name="issue"
              rules={{ required: "Issue Description is required" }}
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    Issue Description By Super Admin <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    value={description} onChange={(e) => setDescription(e.target.value)}
                    className="input-box"
                    placeholder="Enter Description"
                    disabled={isViewMode}
                  />
                  {errors.issue && (
                    <p style={{ color: "red" }}>{errors.issue.message}</p>
                  )}
                </div>
              )}
            />
          </div >
        </form>

        {/* Buttons */}
        <div className="d-flex col-md-11 button_submit ac-jb my-3">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="back_btn f2 fs-sm-15 fs-md-15 fs-lg-17 fs-xl-18 fs-xxl-20"
          >
            Back
          </button>

          <button
            type="submit"
            onClick={() => handlePopup()}
            className="Add_btn f2 fs-sm-15 fs-md-15 fs-lg-17 fs-xl-18 fs-xxl-20"
          >
            Assign
          </button>
        </div>
        {popup && (
          <div className="img-popup-design">
            <div className="img-popup">
              <p className="f3 mt-4 mb-2 f2 fs-xs-14 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 ">
                Are you sure you want to assign?
              </p>
              <div className="d-flex ac-jb px-2 mt-5">
                <button
                  onClick={() => setPopup(false)}
                  className="no-btn f2 w-40"
                >
                  No
                </button>
                <button onClick={() => closeTicket()} className="yes-btn f2 w-40">
                  Yes
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PendingMove;
